export const Status = {
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
  }
 